import { render } from "./EditPostInvoice.vue?vue&type=template&id=08fba5e7&scoped=true"
import script from "./EditPostInvoice.vue?vue&type=script&lang=js"
export * from "./EditPostInvoice.vue?vue&type=script&lang=js"

import "./EditPostInvoice.vue?vue&type=style&index=0&id=08fba5e7&scoped=true&lang=css"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fba5e7"]])

export default __exports__